var _path;
import * as React from "react";
function SvgOldFashioned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 4,6 H 20 V 24 H 4 Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOldFashioned);
export default __webpack_public_path__ + "static/media/OldFashioned.8530350df949dae60d5462330ec2c9e9.svg";
export { ForwardRef as ReactComponent };